import { RootState } from '../store/configureStore';

export const getInvoices = (state: RootState) => state?.invoices?.invoices;

export const isFetchingInvoices = (state: RootState) =>
  state?.invoices?.isFetchingInvoices;

export const didFetchingInvoicesFailed = (state: RootState) =>
  state?.invoices?.fetchingInvoicesFailed;
